import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";

export class generateRuleFromTransactionCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) { }

  async run(transaction_ids): Promise<any> {
    let args = { 
      transaction_ids: transaction_ids
    }
    try {
      await this.dispatcher.dispatch('generate.rule.from.transaction', args)
      this.frontend.$root.$emit('getCompanyBankRules')
    } catch (error) {
      console.error(error)
    }
  }

  async run_async_job(transaction_ids): Promise<any> {
    let args = { 
      transaction_ids: transaction_ids
    }
    try {
      this.frontend.action = 'generate_rules'
      let res = await this.dispatcher.dispatch('generate.rule.from.transaction', args)
      this.frontend.asyncJobState = 'running';
      this.frontend.asyncJobId = res.job_id
    } catch (error) {
      console.error(error)
    }
  }
}